<template>
    <div class="space-untested-areas" v-if="maxNumberOfRows">

        <button type="button" class="btn btn-sm btn-success ml-auto" :disabled="!canAddMoreRows || createForm.isSubmitted" @click="save()">
            <span v-if="!createForm.isSubmitted"><i class="fa fa-plus-circle"></i> Add Untested Space</span>
            <span v-else><i class="fa fa-spin fa-spinner"></i> Saving...</span>
        </button>

        <div class="table-container" v-if="hasUntestedAreas">
            <table class="table mb-3">
                <thead>
                <tr>
                    <th>Building</th>
                    <th>Floor</th>
                    <th>Name</th>
                    <th>Form</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="space in spaceAreas" :key="`space-id-${space.id}`">
                    <td>
                        <input type="text" v-model="space.building" class="form-control">
                    </td>
                    <td>
                        <input type="text" v-model="space.floor" class="form-control">
                    </td>
                    <td>
                        <input type="text" v-model="space.name" class="form-control">
                    </td>
                    <td>
                        <select v-model="space.form_id" class="form-control" @change="update(space)">
                            <option v-for="form in formsAllowedForUntestedArea" :value="form.id" v-text="`(${form.test.id}) ${form.name}`"></option>
                        </select>
                    </td>
                    <td class="text-center">
                        <a href="#" @click="remove(space)" class="text-danger" :disabled="isDeleting == space.id">
                            <i class="fa fa-trash" v-if="isDeleting != space.id"></i>
                            <i class="fa fa-spin fa-spinner" v-else></i>
                        </a>
                    </td>
                    <td>
                        <a href="#" @click="update(space)" class="text-primary">
                            <i class="fa fa-save"></i>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="untested-areas-legend">
            <div v-for="form in formsAllowedForUntestedArea"
                 :key="`test-id-${form.test.id}`"
                 :class="{'text-danger' : (untestedAreasFor(form).length > form.untested_areas) }"
                 v-if="untestedAreasFor(form).length > 0">
                <span v-text="`(${form.test.id}) ${form.name}`"></span> have <b v-text="untestedAreasFor(form).length"></b> of <b v-text="form.untested_areas"></b> max.
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            project: {
                type: Object,
                required: true,
            },
            space: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                spaceAreas: this.space.untested_areas,
                isDeleting: false,
                createForm: new Form({
                    building: this.space.building,
                    floor: this.space.floor,
                    name: '',
                }).dontClear(),
            }
        },

        methods: {

            save() {
                var untested_form = this.formsAllowedForUntestedArea[0];
                this.createForm
                    .post(`/projects/${this.project.slug}/spaces/${this.space.slug}/space-untested-areas/${untested_form.slug}`).then(response => {
                    this.createForm.name = '';
                    this.$nextTick(() => {
                        this.spaceAreas.push(response.space);
                    })
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            },

            update(space) {
                var form_slug = space.form.slug
                var form = space.form;
                let s = Object.assign({}, space)
                delete s.form;
                App.request()
                    .patch(`/projects/${this.project.slug}/spaces/${this.space.slug}/space-untested-areas/${form_slug}`, s)
                    .then(response => {
                        Toast.success('Space Untested Area Updated!')
                    })
                    .catch(errors => {
                        space['form'] = form;
                        Alert.error(errors.first());
                    })
            },

            remove(space) {
                this.isDeleting = space.id;
                var index = this.space.untested_areas.indexOf(space);
                var form_slug = space.form.slug
                delete space.form;
                App.request()
                    .delete(`/projects/${this.project.slug}/spaces/${this.space.slug}/space-untested-areas/${form_slug}`, {params: {space_id: space.id}})
                    .then(response => {
                        this.spaceAreas.splice(index, 1)
                        this.isDeleting = false;
                        Toast.success('Space Untested Area Deleted!')
                    })
            },

            untestedAreasFor(form) {
                return this.space.untested_areas.filter(area => {
                    return area.form_id == form.id;
                })
            },
        },

        computed: {

            formsAllowedForUntestedArea() {
                return this.space.forms.filter(form => {
                    return form.untested_areas != null && form.test.is_passed;
                })
            },

            maxNumberOfRows() {
                var number = 0;
                this.formsAllowedForUntestedArea.forEach(form => {
                    if (form.test.is_passed) {
                        number += form.untested_areas;
                    }
                })
                return number;
            },

            canHaveUntestedAreasForms() {
                return !!this.formsAllowedForUntestedArea.length;
            },

            canAddMoreRows() {
                return this.spaceAreas.length < this.maxNumberOfRows;
            },

            hasUntestedAreas() {
                return this.spaceAreas.length;
            }
        }
    }
</script>
